export const apiSettings = JSON.parse(process.env.VUE_APP_API_CONFIG)